import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DragDrop from "../DragDrop/DragDrop";
import { useGlobalState } from "../Context/GlobalStateContext";
import moment from "moment";
import SignaturePadControl from "../App/SignaturePadControl";

export default function ProgramApproval() {
  const globalState = useGlobalState();

  const [programGridData, setProgramGridData] = useState([]);
  const [programSectionGridData, setProgramSectionGridData] = useState([]);

  const [showAnimation, setShowAnimation] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  const [programData, setProgramData] = useState({}) as any;
  const [programSectionData, setProgramSectionData] = useState({}) as any;

  //MM:: Approval related data
  const [requiredApproval, setRequiredApproval] = useState([]) as any;
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;
  const [approvalDataModal, setApprovalDataModal] = useState(false);
  const [approvalData, setApprovalData] = useState({}) as any;

  //MM:: LoggedInUserID
  const [LoggedInUserID, setLoggedInUserID] = useState(0);

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  useEffect(() => {
    if (!globalState.ManageAdmin && !globalState.DirectorAccess && !globalState.OverseasAccess) {
      window.location.href = "scorecard";
    }

    const search = window.location.search;
    const params = new URLSearchParams(search);

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") {
      IBBProgramID = Number(IBBProgramID);
    } else IBBProgramID = programData.IBBProgramID;

    setProgramData((prevState: any) => ({
      ...prevState,
      IBBProgramID: IBBProgramID,
    }));

    IBBProgramGetCompleteGridDataCustom(IBBProgramID);
  }, []);

  useEffect(() => {
    let IBBProgramID = programData.IBBProgramID;
    if (
      IBBProgramID > 0 &&
      programGridData.length > 1 &&
      programGridData.length > 0
    ) {
      let filtered = programGridData.filter(
        (item: any) => item.IBBProgramID == IBBProgramID
      ) as any;
      if (filtered.length > 0) {
        setProgramData(filtered[0]);

        IBBProgramSectionGetCompleteGridDataCustom(IBBProgramID);

        setRequiredApproval([]);
        setRequiredApprovalUser([]);

        if (filtered[0].Status == 0) setCanEdit(true);
        else {
          setCanEdit(false);

          IBBRequiredApprovalUserGetDataForApproval(
            IBBProgramID,
            filtered[0].SubStatus
          );
        }
      }
    }
  }, [programData.IBBProgramID]);

  useEffect(() => {
    calculateTotalAssignedPercentage();
  }, [programSectionGridData]);

  function IBBProgramGetCompleteGridDataCustom(IBBProgramID: number = 0) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    object.sortexpressions = "ibbprogramid";
    object.sortdirection = "D";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setProgramGridData(result[1]);

          if (IBBProgramID == 0 && result[1].length > 0) {
            setProgramData((prevState: any) => ({
              ...prevState,
              IBBProgramID: Number(result[1][0].IBBProgramID),
            }));
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramSectionGetCompleteGridDataCustom(ibbprogramid: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = ibbprogramid;
    object.isdeleted = false;
    object.recordsperpage = 100;
    object.sortexpressions = "Type";
    object.sortdirection = "A";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramSection/IBBProgramSectionGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          let reEarnables = result[1];
          setProgramSectionGridData(reEarnables);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function calculateTotalAssignedPercentage() {
    let filtered = programSectionGridData.filter(
      (item: any) => item.Type == 2
    ) as any;
    const totalPercentage = filtered.reduce(
      (total: any, item: any) => (total = total + item.Value),
      0
    );
    setProgramSectionData((prevState: any) => ({
      ...prevState,
      TotalPercentage: totalPercentage,
    }));
  }

  function IBBRequiredApprovalUserGetDataForApproval(
    IBBProgramID: number,
    SubStatus: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = programData.IBBProgramID;

    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = IBBProgramID;
    object.ibbprogramstageid = SubStatus;
    object.ibbprogramsectionid = 0;
    object.ibbrequiredapprovalid = 0;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApprovalUser/IBBRequiredApprovalUserGetDataForApproval",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setRequiredApproval(result[0]);
          setRequiredApprovalUser(result[1]);
          if (result.length > 2 && result[2].length > 0) {
            let userID = result[2][0].UserID;
            //userID = 235;
            setLoggedInUserID(userID);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  //Dragdrop starts

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: AppContext.FileUploadObjectTypeApprovalFile,
    MaxAllowedFiles: 1,
    UploadType: 3,
    FolderName: "IBB-Approval-Data",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [showDragdrop, setShowDragdrop] = useState(true);

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  function showPopUpForSaveFiles(ObjectType: number, ObjectID: number) {
    let isOkayToGo = false;

    if (approvalData.IsSignatureRequired == true) {
      if (approvalData.SignatureData && approvalData.SignatureData != "") {
        isOkayToGo = true;
      } else {
        isOkayToGo = false;
      }
    } else if (approvalData.IsSignatureRequired == false) {
      isOkayToGo = true;
    }

    if (isOkayToGo) {
      var ApprovalFile = AppContext.FileUploadObjectTypeApprovalFile;
      var ProgramPolicy = AppContext.FileUploadObjectTypeProgramPolicy;

      if (uploadFileList && uploadFileList.length > 0)
        SaveFiles(ObjectType, ObjectID);
      else if (ObjectType == ApprovalFile) IBBApprovalSaveCustom([]);
      else if (ObjectType == ProgramPolicy)
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "Alert",
        Message: "Please select file to upload.",
      });
    } else {
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "Alert",
        Message: "Signature is required",
      });
    }
  }

  function SaveFiles(ObjectType: number, ObjectID: number) {
    if (uploadFileList && uploadFileList.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = ObjectType;
      object.objectid = ObjectID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            var ApprovalFile = AppContext.FileUploadObjectTypeApprovalFile;
            var ProgramPolicy = AppContext.FileUploadObjectTypeProgramPolicy;
            if (ObjectType == ApprovalFile) IBBApprovalSaveCustom(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
          //setShowAnimation(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      //saveConactUsData([]);
    }
  }
  //Dragdrop ends

  function IBBApprovalSaveCustom(uploadedFileList: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbrequiredapprovaluserid = approvalData.IBBRequiredApprovalUserID;
    object.ibbdelegatedid = approvalData.IBBDelegateID;
    object.ibbprogramid = programData.IBBProgramID;
    object.quarterid = 0;
    object.name = approvalData.Name;
    object.status = approvalData.Status;
    object.notes = approvalData.Notes;
    object.objecttype = programData.SubStatus;
    object.objectid = programData.IBBProgramID;
    object.signaturedata = approvalData.SignatureData;
    object.filesdata = uploadedFileList;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBApproval/IBBApprovalSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setApprovalDataModal(false);
          IBBRequiredApprovalUserGetDataForApproval(
            programData.IBBProgramID,
            programData.SubStatus
          );
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  const handleSave = (signatureDataUrl: string) => {
    // console.log("Signature data URL received in parent:", signatureDataUrl);
    approvalData.SignatureData = signatureDataUrl;
  };

  return (
    <>
      {showAnimation && <LoadingAnimation />}

      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Program Approval</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items">
              <select
                className="select-md"
                value={programData.IBBProgramID}
                onChange={(e) =>
                  setProgramData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                  }))
                }
              >
                {programGridData &&
                  programGridData.map((Item: any, index: any) => (
                    <option
                      value={Item.IBBProgramID}
                      key={"year" + Item.IBBProgramID}
                    >
                      {Item.Name}
                    </option>
                  ))}
              </select>
            </div>

            <span style={{ width: "33.33%" }}></span>
          </div>
          <div className="section-table">
            <div className="papp-grid-sm">
              <div></div>
              <div className="vrm-grid">
                <table className="part-head trend-table fixed-table">
                  <thead>
                    <tr>
                      <th>
                        VRM FY
                        {AppContext.YearList &&
                          AppContext.YearList.map((item: any, index: any) => (
                            <>
                              {item.PID == programData.NumericYear && (
                                <span> {item.Name}</span>
                              )}
                            </>
                          ))}
                      </th>
                      <th className="text-center vrm-back-w">MENA</th>
                    </tr>
                  </thead>
                </table>
                <table className="part-head trend-table">
                  <thead>
                    <tr>
                      <th>VRM</th>
                      <th className="text-center" rowSpan={2}>
                        Fixed Structure Under Review
                      </th>
                    </tr>
                    <tr>
                      <th className="vrm-back-w2">
                        {programSectionData.TotalPercentage?.toLocaleString(
                          undefined,
                          { minimumFractionDigits: 2 }
                        )}
                        %
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
            <div className="papp-grid">
              <div className="gate-way-grid">
                <div className="table-gw">
                  <table className="part-head trend-table">
                    <thead>
                      <tr>
                        <th colSpan={2}>Gateway</th>
                      </tr>
                      <tr>
                        <th>Criteria</th>
                        <th>Measurement</th>
                      </tr>
                    </thead>
                    <tbody>
                      {programSectionGridData &&
                        programSectionGridData.map((item: any, index: any) => (
                          <>
                            {item.Type == 1 && (
                              <React.Fragment
                                key={"programSectiongateway" + index}
                              >
                                <tr>
                                  <td className="text-center">{item.Title}</td>
                                  <td className="text-center">
                                    {item.Description}
                                  </td>
                                </tr>
                              </React.Fragment>
                            )}
                          </>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* <div className="table-comments">
                  <table className="part-head trend-table">
                    <thead>
                      <tr>
                        <th>Comments</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-center">
                          Lorem Ipsum Sit dolor amit Lorem Ipsum Sit dolor amit
                          Lorem Ipsum Sit dolor amit Lorem Ipsum Sit dolor amit
                          Lorem Ipsum Sit dolor amit
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div> */}
              </div>
              {programData.IBBProgramID > 0 && (
                <>
                  <div className="margin-table">
                    <table className="part-head trend-table">
                      <thead>
                        <tr>
                          <th colSpan={4}>Margin</th>
                        </tr>
                        <tr>
                          <th>Criteria</th>
                          <th>Measurement</th>
                          <th>% Available</th>
                          <th>% Weight</th>
                        </tr>
                      </thead>
                      <tbody>
                        {programSectionGridData &&
                          programSectionGridData.map(
                            (item: any, index: any) => (
                              <>
                                {item.Type == 2 && (
                                  <React.Fragment
                                    key={"programSection" + index}
                                  >
                                    <tr>
                                      <td>
                                        {item.Title}
                                        {/* &nbsp;(
                                        {item.ShortTitle}) */}
                                      </td>
                                      <td className="text-center">
                                        {item.Description}
                                      </td>
                                      <td className="text-right">
                                        {item.Value?.toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                        })}
                                        %
                                      </td>
                                      <td className="text-right">
                                        {(
                                          (item.Value /
                                            programSectionData.TotalPercentage) *
                                          100
                                        ).toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                        %
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                )}
                              </>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="section-table">
            <div className="grid-box-ibb fr-pg-1">
              <div className="pg-importers fr-1-pg">
                {requiredApprovalUser && requiredApprovalUser.length > 0 && (
                  <div className="pg-importers appr-grid grid-signoff prg-aproval">
                    {requiredApproval &&
                      requiredApproval.map((item: any, index: any) => (
                        <React.Fragment key={"requiredapproval" + index}>
                          <div className="appr-main">
                            <div className="appr-head">
                              <span>
                                {item.IBBProgramStageName}{" "}
                                {item.IBBProgramSectionName && (
                                  <> - {item.IBBProgramSectionName}</>
                                )}
                              </span>
                            </div>
                            <div className="exceptions-right">
                              {requiredApprovalUser &&
                                requiredApprovalUser.map(
                                  (itemUser: any, indexUser: any) => (
                                    <React.Fragment
                                      key={"requiredapprovaluser" + indexUser}
                                    >
                                      {item.IBBRequiredApprovalID ==
                                        itemUser.IBBRequiredApprovalID && (
                                        <>
                                          <div className="req-by">
                                            <div className="req-left">
                                              <span className="req-title"></span>
                                              <span className="req-val">
                                                {itemUser.JobRoleTitle !=
                                                  "" && (
                                                  <>
                                                    {" "}
                                                    {
                                                      itemUser.JobRoleTitle
                                                    } /{" "}
                                                  </>
                                                )}
                                                {itemUser.UserName}
                                                {itemUser.Status != 0 && (
                                                  <>
                                                    {itemUser.OnBehalfText !=
                                                      "" && (
                                                      <span className="signed-by">
                                                        ({itemUser.OnBehalfText}
                                                        )
                                                      </span>
                                                    )}
                                                  </>
                                                )}
                                              </span>
                                            </div>
                                            {itemUser.Status != 0 && (
                                              <div className="req-center">
                                                {itemUser.SignatureData &&
                                                  itemUser.SignatureData !=
                                                    null && (
                                                    <img
                                                      src={
                                                        itemUser.SignatureData
                                                      }
                                                      height={30}
                                                    />
                                                  )}
                                                <span>
                                                  {moment(
                                                    itemUser.ApprovalTime
                                                  )?.format(
                                                    "MMMM DD, YYYY hh:mm"
                                                  )}
                                                </span>
                                              </div>
                                            )}
                                            <div className="req-right">
                                              {itemUser.FileURL && (
                                                <a
                                                  href={itemUser.FileURL}
                                                  target="blank"
                                                  title="Click to download attachment"
                                                >
                                                  1
                                                </a>
                                              )}
                                              {itemUser.Notes && (
                                                <a
                                                  onClick={() => {
                                                    setPopUpMessage(
                                                      itemUser.Notes
                                                    );
                                                    setPopUpMessageModal(true);
                                                  }}
                                                  title={itemUser.Notes}
                                                >
                                                  <img
                                                    src="images/message.svg"
                                                    width={15}
                                                    height={15}
                                                  />
                                                </a>
                                              )}

                                              {itemUser.CanTakeAction == 1 && (
                                                <>
                                                  <a
                                                    style={{
                                                      background: "green",
                                                    }}
                                                    className="req-yes"
                                                    title="Approve"
                                                    onClick={() => {
                                                      let approvalDataLocal =
                                                        {} as any;
                                                      approvalDataLocal.IBBRequiredApprovalUserID =
                                                        itemUser.IBBRequiredApprovalUserID;
                                                      approvalDataLocal.IBBDelegateID =
                                                        itemUser.IBBDelegateID;
                                                      approvalDataLocal.Status = 1;
                                                      approvalDataLocal.IsSignatureRequired =
                                                        itemUser.IsSignatureRequired;

                                                      setApprovalData(
                                                        approvalDataLocal
                                                      );
                                                      setApprovalDataModal(
                                                        true
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src="images/tick.svg"
                                                      width={15}
                                                      height={15}
                                                    />
                                                  </a>
                                                  <a
                                                    style={{
                                                      background: "red",
                                                    }}
                                                    className="req-yes"
                                                    title="Reject"
                                                    onClick={() => {
                                                      let approvalDataLocal =
                                                        {} as any;
                                                      approvalDataLocal.IBBRequiredApprovalUserID =
                                                        itemUser.IBBRequiredApprovalUserID;
                                                      approvalDataLocal.IBBDelegateID =
                                                        itemUser.IBBDelegateID;
                                                      approvalDataLocal.Status = 2;
                                                      approvalDataLocal.IsSignatureRequired =
                                                        itemUser.IsSignatureRequired;
                                                      setApprovalData(
                                                        approvalDataLocal
                                                      );
                                                      setApprovalDataModal(
                                                        true
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src="images/cross-w.svg"
                                                      width={15}
                                                      height={15}
                                                    />
                                                  </a>
                                                </>
                                              )}

                                              {itemUser.Status > 0 && (
                                                <>
                                                  {itemUser.Status == 1 && (
                                                    <span className="req-yes">
                                                      APPROVED
                                                    </span>
                                                  )}
                                                  {itemUser.Status == 2 && (
                                                    <span className=" req-yes req-no">
                                                      REJECTED
                                                    </span>
                                                  )}
                                                </>
                                              )}
                                              {itemUser.Status == 0 &&
                                                itemUser.CanTakeAction == 0 && (
                                                  <>
                                                    <span className="req-pend">
                                                      PENDING
                                                    </span>
                                                  </>
                                                )}
                                            </div>
                                          </div>

                                          {itemUser.IsStartSection && (
                                            <div className="req-hr"></div>
                                          )}
                                        </>
                                      )}
                                    </React.Fragment>
                                  )
                                )}
                            </div>
                          </div>
                        </React.Fragment>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {approvalDataModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Confirmation</h3>
                <a
                  className="close-help"
                  onClick={() => setApprovalDataModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">
                {approvalData.IsSignatureRequired && (
                  <>
                    <span className="buis-head">Signature</span>
                    <SignaturePadControl
                      onSave={handleSave}
                    ></SignaturePadControl>
                  </>
                )}
                <div className="flex-items supp-doc">
                  <span>Supporting Document:</span>
                  <div className="order-drag">
                    <DragDrop
                      ParentFeatures={dragDropFeatures}
                      DragDropCallback={handleDragDropCallback}
                      TriggerChild={triggerChild}
                    />
                  </div>
                </div>
              </div>
              <div className="help-btns">
                <div>
                  Are you sure you want to{" "}
                  <b>{approvalData.Status == 1 ? "Approve" : "Reject"}</b> it?
                  You will not be able to revert it.
                </div>
                <a
                  onClick={() => {
                    showPopUpForSaveFiles(
                      AppContext.FileUploadObjectTypeApprovalFile,
                      approvalData.IBBRequiredApprovalUserID
                    );
                  }}
                >
                  Yes
                </a>
                <a onClick={() => setApprovalDataModal(false)}>No</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
